import { Link } from '@tanstack/react-router';

import { cx } from '@libs/classnames';
import { Badge } from '@ui/components/Badge';
import { SlimArrowButton } from '@ui/components/SlimArrowButton';
import { FeatherIcon } from '@ui/icons/FeatherIcon';

import styles from './GameInfo.module.css';

export type Props = {
  className?: string;
  title: string;
  specs: string[];
  alt?: string;
  isRating?: boolean;
  mobileBackLink?: string;
  mobileBacklinkIsLogo?: boolean;
  twoAvatars?: boolean;
  onMobileBackClick?: () => void;
};

export function GameInfo({
  className,
  title,
  specs,
  alt,
  isRating,
  mobileBackLink,
  mobileBacklinkIsLogo,
  twoAvatars,
  onMobileBackClick,
}: Props) {
  return (
    <section
      className={cx(styles.root, className, {
        [styles.has_mobile_back]: mobileBackLink || onMobileBackClick,
        [styles.has_two_avatars]: twoAvatars,
      })}
    >
      {(mobileBackLink || onMobileBackClick) && (
        <Link
          to={mobileBackLink}
          onClick={
            onMobileBackClick
              ? (e) => {
                  e.preventDefault();
                  onMobileBackClick();
                }
              : undefined
          }
          className={styles.mobile_backlink}
        >
          {mobileBacklinkIsLogo ? (
            <FeatherIcon className={styles.mobile_logo} />
          ) : (
            <SlimArrowButton direction="left" size="20" colorPreset="currentColor" />
          )}
        </Link>
      )}
      <h1 className={styles.title} title={title} translate="yes">
        {title}
      </h1>
      <p className={styles.specs}>
        {alt ?? specs.join(' · ')}
        {isRating && (
          <Badge className={styles.specs__badge} size="xs">
            На рейтинг
          </Badge>
        )}
      </p>
    </section>
  );
}
